var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4, _circle5, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Claim Approved Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3984 34L18.6154 55.0869C18.3625 55.8731 19.1176 56.6095 19.8972 56.3372L40.8984 49",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0716 37.414C39.3177 39.7684 40.8788 42.2835 41.6128 44.4116C42.3781 46.6306 42.1348 48.0389 41.4741 48.6692C40.8135 49.2994 39.3953 49.4762 37.2148 48.6074C35.1235 47.7741 32.6847 46.0965 30.4386 43.7421C28.1924 41.3877 26.6313 38.8726 25.8974 36.7445C25.1321 34.5255 25.3754 33.1172 26.036 32.4869C26.6966 31.8567 28.1149 31.6799 30.2954 32.5487C32.3866 33.382 34.8254 35.0597 37.0716 37.414Z",
    stroke: "#000000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7014 33.6234C38.433 31.1991 40.7533 24.4805 36.1819 17",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9159 39.124C57.3717 39.4359 57.994 39.3192 58.3059 38.8634C58.6177 38.4076 58.501 37.7853 58.0452 37.4734L56.9159 39.124ZM38.9241 40.6046C40.3696 39.3197 43.0465 37.6701 46.2831 36.9917C49.4897 36.3196 53.2279 36.6007 56.9159 39.124L58.0452 37.4734C53.837 34.5941 49.5234 34.2691 45.8728 35.0343C42.2522 35.7931 39.2668 37.6241 37.5954 39.1097L38.9241 40.6046Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0129 41.4546C44.4607 41.4546 44.0129 41.9023 44.0129 42.4546C44.0129 43.0069 44.4607 43.4546 45.0129 43.4546V41.4546ZM48.8308 45.5665C49.1149 46.0401 49.7292 46.1936 50.2028 45.9095C50.6763 45.6253 50.8299 45.0111 50.5458 44.5375L48.8308 45.5665ZM45.0129 43.4546C45.8666 43.4546 47.8363 43.909 48.8308 45.5665L50.5458 44.5375C49.0467 42.0391 46.2372 41.4546 45.0129 41.4546V43.4546Z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6142 23.2122C28.1792 22.872 27.5507 22.949 27.2105 23.384C26.8703 23.8191 26.9473 24.4476 27.3823 24.7878L28.6142 23.2122ZM29.0891 28.8031C29.0213 29.3512 29.4106 29.8505 29.9587 29.9184C30.5068 29.9862 31.0061 29.5969 31.074 29.0488L29.0891 28.8031ZM27.3823 24.7878C28.0548 25.3136 29.3266 26.8848 29.0891 28.8031L31.074 29.0488C31.432 26.1573 29.5787 23.9663 28.6142 23.2122L27.3823 24.7878Z",
    fill: "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4935,
    cy: 29.4675,
    r: 1.55844,
    fill: "#000000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.7274,
    cy: 39.8571,
    r: 1.55844,
    fill: "#000000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1039,
    cy: 24.2727,
    r: 1.55844,
    fill: "#000000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 11.5,
    fill: "#05C379"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3904 59.8536L61.2913 67.7073L57.6099 64.1375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimApproved);
export default __webpack_public_path__ + "static/media/claim-approved.9cceb6d40672dd77eeff48c61132e0bf.svg";
export { ForwardRef as ReactComponent };